import type {
  FinancialTransactionWithTerreiroId,
  FinancialTransactionWithIdAndTerreiroId,
} from "./incoming.repository";
import { axiosClient } from "../api/axiosClient";

/**
 * Repository for outgoing transactions (expenses / outcomes)
 */
export const outgoingRepository = {
  /**
   * Create an outgoing (saida) transaction.
   * POST /v1/outgoing
   */
  createOutgoing: async (payload: FinancialTransactionWithTerreiroId) => {
    const { data } = await axiosClient.post("/outcome", payload, {
      withCredentials: true,
    });
    return data;
  },

  /**
   * Edit an outgoing (saida) transaction.
   * PUT /outcome/:id
   */
  editOutgoing: async (payload: FinancialTransactionWithIdAndTerreiroId) => {
    const { id, ...rest } = payload;
    const { data } = await axiosClient.put(`/outcome/${id}`, rest, {
      withCredentials: true,
    });
    return data;
  },

  /**
   * Get a single outgoing (saida) transaction by id.
   * GET /outcome/:id
   */
  getOutgoingById: async (id: string) => {
    const { data } = await axiosClient.get(`/outcome/${id}`, {
      withCredentials: true,
    });
    return data;
  },

  updateSettlementStatus: async (
    id: string,
    settlementStatus: "PROJECTED" | "CONSOLIDATED",
  ) => {
    const { data } = await axiosClient.patch(
      `/outcome/${id}/settlement-status`,
      { settlementStatus },
      { withCredentials: true },
    );
    return data;
  },
};
